<template>
  <el-dialog
    class="start-approval-modal"
    width="90%"
    top="60px"
    title="发起企业微信审批"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="form">
      <div v-if="!isBatch" class="field">
        <label>审批类型</label>
        <div style="line-height: 28px;">
          <el-radio v-model="context.approvalType" :label="1">批单</el-radio>
          <el-radio v-model="context.approvalType" :label="3">特价现货</el-radio>
        </div>
      </div>
      <template v-if="context.approvalType === 1">
        <div class="field">
          <label>是否挂账</label>
          <div style="line-height: 28px;">
            <el-checkbox v-model="context.bizPayload.creditPay"></el-checkbox>
          </div>
        </div>
        <div v-if="context.bizPayload.creditPay" class="field">
          <label>预付金额</label>
          <div>
            <el-input-number v-model="context.bizPayload.prePayAmount" :min="0" :controls="false" :step="0.01" :step-strictly="true" :precision="2" size="mini" placeholder="可以填0" />
          </div>
        </div>
        <div v-if="context.bizPayload.creditPay" class="field">
          <label>公司主体</label>
          <div>
            <el-select v-model="context.bizPayload.subSellerId" size="mini" :clearable="false" style="width: 100%;" placeholder="请选择挂账公司">
              <el-option label="上海兆配科技有限公司" value="option-1769063984451"></el-option>
              <el-option label="北京兆配电子商务有限公司" value="option-1770605076609"></el-option>
              <el-option label="成都兆配电子商务有限公司" value="option-1769064009655"></el-option>
              <el-option label="杭州彤冉汽车配件有限公司" value="option-1769064198894"></el-option>
              <el-option label="武汉彤配汽车科技有限公司" value="option-1769064022878"></el-option>
              <el-option label="长沙彤冉汽车科技有限公司" value="option-1779677646921"></el-option>
            </el-select>
          </div>
        </div>
        <div class="field">
          <label>是否包邮</label>
          <div style="line-height: 28px;">
            <el-checkbox v-model="context.bizPayload.freeShipping"></el-checkbox>
          </div>
        </div>
        <div v-if="context.bizPayload.freeShipping" class="field">
          <label>预估邮费</label>
          <div>
            <el-input-number v-model="context.bizPayload.shippingFee" :min="0" :controls="false" :step="0.01" :step-strictly="true" :precision="2" size="mini" placeholder="预计包邮费用" />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="field">
          <label>用途</label>
          <div>
            <el-select v-model="context.bizPayload.orderType" size="mini" :clearable="false" style="width: 100%;">
              <el-option label="直接销售" value="直接销售"></el-option>
              <el-option label="线上引流" value="线上引流"></el-option>
            </el-select>
          </div>
        </div>
        <div class="field">
          <label>是否包邮</label>
          <div style="line-height: 28px;">
            <el-checkbox v-model="context.bizPayload.freeShipping"></el-checkbox>
          </div>
        </div>
        <div v-if="context.bizPayload.freeShipping" class="field">
          <label>预估邮费</label>
          <div>
            <el-input-number v-model="context.bizPayload.shippingFee" :min="0" :controls="false" :step="0.01" :step-strictly="true" :precision="2" size="mini" placeholder="预计包邮费用" />
          </div>
        </div>
        <div class="field">
          <label>预估利润</label>
          <div>
            <el-input-number v-model="context.bizPayload.profit" :min="0" :controls="false" :step="0.01" :step-strictly="true" :precision="2" size="mini" placeholder="预计销售利润" />
          </div>
        </div>
        <div class="field">
          <label>其他费用</label>
          <div>
            <el-input-number v-model="context.bizPayload.otherFee" :min="0" :controls="false" :step="0.01" :step-strictly="true" :precision="2" size="mini" placeholder="调拨/包邮费用" />
          </div>
        </div>
      </template>
      <div class="field">
        <label>审批备注</label>
        <div>
          <el-input type="textarea" v-model="context.bizPayload.memo" placeholder="请输入审批备注"></el-input>
        </div>
      </div>
      <div class="action" style="text-align: right;">
        <el-button @click="close(false)" type="default" size="small">取消</el-button>
        <el-button @click="doSubmit" type="primary" size="small">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { TriggerApproval } from '../services'
export default {
  name: 'StartApprovalModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      isBatch: false,
      context: {
        bizNo: '',
        approvalType: 1,
        bizPayload: {
          subSellerId: 'option-1769063984451',
          freeShipping: false,
          shippingFee: 0,
          creditPay: false,
          prePayAmount: 0,
          memo: '',
          orderType: '直接销售',
          otherFee: 0,
          profit: 0
        }
      }
    }
  },
  methods: {
    init (orderSn, isBatch) {
      this.context.bizNo = orderSn
      this.isBatch = isBatch
      return this.open()
    },
    doSubmit () {
      const { bizNo, approvalType, bizPayload } = this.context
      if (approvalType === 3) {
        if (bizPayload.freeShipping && bizPayload.shippingFee <= 0) {
          this.$message.error('请输入预估包邮费用')
          return
        }
      }
      TriggerApproval({
        bizNo,
        approvalType,
        memo: JSON.stringify(bizPayload)
      }).then((resp) => {
        this.close(true)
      })
    }
  }
}
</script>
<style lang="stylus">
.start-approval-modal
  .el-dialog
    max-width 480px
    .form
      .field
        display flex
        flex-direction row
        margin-bottom 14px
        align-content center
        >label
          text-align right
          width 70px
          margin-right 4px
          line-height 28px
          flex-shrink 0
          &:after
            content: '\ff1a'
          +div
            flex-grow 1
        .el-input-number
          width 100%
          input
           text-align left
</style>
